export default {
  title: 'Zrealizowane akcje',
  tooltip: 'Kliknij aby poznać dotychczas zrealizowane przez nas projekty',
  noResults: 'Brak wyników',
};
